import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Swal from 'sweetalert2';
import Loading from 'react-simple-loading';



const RemoveAccount = () => {
    const navigate = useNavigate();
    const [isBtn, setIsBtn] = useState(false);
    const [errorResponse, setErrorResponse] = useState(false);


    const removeAccount = async (e) => {
        if (!localStorage.getItem('@roampays-user')) {
            navigate("/login")
        }
        setIsBtn(true);
        setErrorResponse(null);


        setIsBtn(true);
        await axios.post(process.env.REACT_APP_API_URL + "/remove-account", {}, {
            headers: {
                'Content-Type': 'application/json'
            },
            withCredentials: true
        })
            .then(function (response) {
                setIsBtn(false)
                if (response?.data?.status) {

                    setErrorResponse("Your account remove request has been sent successfully.");

                    setTimeout(function () {
                        localStorage.removeItem("@email");
                        localStorage.removeItem('@roampays-user');
                        navigate("/login")
                    }, 3000);

                } else {

                    Swal.fire({ icon: "error", title: "Remove Account Request Failed", text: response?.data?.message });

                }
            })
            .catch(function (error) {
                setIsBtn(false)

                Swal.fire({ icon: "error", title: "Remove Account Request Failed", text: error.message });

            });


    };


    const backToProfile = async (e) => {
        navigate("/profile")
    };

    return (


        <>




<div className="title-box">

<div className="flex-equal justify-content-start " >
    <button className="btn btn-link fs-12 d-flex fd-row align-items-center" onClick={backToProfile} >

        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M5.69765 6.99997L8.68205 4.01557L7.65085 2.98438L3.63525 6.99997L7.65085 11.0156L8.68205 9.98438L5.69765 6.99997Z" fill="white" />
        </svg>
        <label >Back</label>

    </button>

</div>
<h3 className="flex-equal justify-content-center fs-32 fs-helvetica color-white">Delete Account</h3>
<div className="flex-equal justify-content-end" ></div>

</div>



            <div className="box" >

                <div className="form-content" >
                    {errorResponse ?
                        <div className="fs-14  color-white" role="alert">
                            {errorResponse}
                        </div>
                        :
                        <>
                            <div className="" >
                                <h3 className="color-white fs-26 text-center">Are you sure?</h3>

                                <label type="text" className="d-flex color-light fs-16 text-center" >
                                    Deleting your account will send request to administrator to permanently remove all your data, including your contracts and saved preferences.
                                </label>


                            </div>

                            <button type="button" onClick={() => removeAccount()} className="btn btn-danger" disabled={isBtn}>
                                {isBtn ? <Loading size={'20px'} /> : ' Yes, delete my account'}

                            </button>
                            <label className="color-light fs-12 text-center" >This action cannot be undone</label>
                        </>
                    }
                </div>





            </div>



        </>


    );
};

export default RemoveAccount;